import React from 'react'
import logo from "../assets/logo.png"

const Footer = () => {
    return (
        <>
         <div className='h-full md:w-[1442px] w-full flex items-center justify-center flex-col'>
            <div className='bg-black pb-5 flex items-center justify-center flex-col'>
                <img src={logo} alt="Logo" className='md:mt-0 mt-32'/>
                <nav>
                    <ul className='flex items-center justify-center md:gap-5 gap-2 mt-5'>
                        <li><a href='/'>Home</a></li>
                        <li><a href='/'>Token</a></li>
                        <li><a href='/'>Refferal</a></li>
                        <li><a href='/'>Roadmap</a></li>
                        <li><a href='/'>Register</a></li>
                        <li><a href='/'>FAQ</a></li>
                    </ul>
                </nav>
            </div>
            </div>
        </>
    )
}

export default Footer
